import { createOAuthClient } from '@rentflowdev/api'

export const oauthApi = createOAuthClient(import.meta.env.VITE_API_URL as string)
